import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { CREATE_USER, PAGINATE_USERS, UPDATE_USER } from 'queries/userQueries';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userCreator } from 'state/index';

const usePaginateUsers = () => {
    const dispatch = useDispatch();
    const { paginateUsers } = bindActionCreators(userCreator, dispatch)
    
        const {
          data,
          loading,
          error,
          refetch,
          networkStatus
        } = useQuery(PAGINATE_USERS, {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache'
        });
      
        useEffect(() => {
            if (data?.paginateUsers) {
                paginateUsers(data.paginateUsers);
            }
        }, [data, paginateUsers]);
      
        return {
          loading,
          error,
          refetch,
          networkStatus
        };
};

const useLazyPaginateUsers = () => {
    const dispatch = useDispatch();
    const { paginateUsers } = bindActionCreators(userCreator, dispatch)

    const [query, result] = useLazyQuery(PAGINATE_USERS);

    useEffect(() => {
        if (result.data?.paginateUsers) {
            console.log(result.data.paginateUsers);
            paginateUsers(result.data.paginateUsers);
        }
    }, [result.data]);

    return [query, result] as const;
}

const useCreateUser = ({ onSuccess, onError }: any) => {
    const dispatch = useDispatch()
    const { createUser } = bindActionCreators(userCreator, dispatch)

    return useMutation(CREATE_USER, {
        onCompleted: (data) => {
            createUser(data.createUser)
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            console.log("network error", error.networkError)
            console.log("graphql error", error.graphQLErrors)
            if(onError) onError(error);
        }
    })
}

const useUpdateUser = ({ onSuccess, onError }: any) => {
    const dispatch = useDispatch()
    const { updateUser } = bindActionCreators(userCreator, dispatch)

    return useMutation(UPDATE_USER, {
        onCompleted: (data) => {
            updateUser(data.updateUser)
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if(onError) onError(error);
        }
    })
}

// const useGetUser = (id: string | undefined) => {
//     const dispatch = useDispatch()
//     const { getUser: viewUser } = bindActionCreators(userCreators, dispatch)

//     return useQuery(['user'], () => getUser(id), {
//         onSuccess: (data) => {
//             viewUser(data)
//         },
//     })
// }

// const useUpdateUser = (id: string, { onSuccess, onError }) => {
//     const dispatch = useDispatch()
//     const { createUser } = bindActionCreators(userCreators, dispatch)

//     return useMutation(['updateUser'], (data) => putUser(id, data), {
//         onSuccess: (data) => {
//             createUser(data)
//             if(onSuccess) onSuccess(data)
//         },
//         onError: (error) => {
//             if(onError) onError()
//         }
//     })
// }

// const useDeleteUser = ({ onSuccess, onError }) => {
//     const dispatch = useDispatch()
//     const { deleteUser } = bindActionCreators(userCreators, dispatch)

//     return useMutation(['deleteUser'], (id: string) => destoryUser(id), {
//         onSuccess: (data) => {
//             deleteUser(data.id)
//             if(onSuccess) onSuccess(data)
//         },
//         onError: (error) => {
//             if(onError) onError()
//         }
//     })
// }

export {
    usePaginateUsers,
    useLazyPaginateUsers,
    useCreateUser,
    // useGetUser,
    useUpdateUser,
    // useDeleteUser
}